import React from "react";
import { Link } from "react-router-dom";
import { Mail, ArrowRight } from "lucide-react";
import { Reveal } from "../hooks/useReveal";
import { SUPPORT_EMAIL, POWERED_BY_TEXT } from "../data/siteContent";

const ContactFooter = ({ children }) => {
  return (
    <>
      <section
        className="bg-ink border-t border-white/8 py-20 sm:py-28"
        data-testid="contact-section"
      >
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
          <Reveal>
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
              <div className="max-w-xl">
                <div className="flex items-center gap-3 text-[11px] sm:text-xs tracking-[0.3em] uppercase font-semibold text-gold">
                  <span className="h-px w-10 bg-gold/60" />
                  Not Ready for the Portal Yet?
                </div>
                <h2 className="font-display text-2xl sm:text-3xl text-cream tracking-tight leading-[1.1] mt-5">
                  Email Me <em className="text-gold italic">Directly.</em>
                </h2>
                <p className="text-cream/65 leading-relaxed mt-4 text-sm sm:text-base">
                  No forms. No pressure. Send me your questions and I will
                  answer them personally. When you are ready, the portal will
                  be right here waiting.
                </p>
              </div>
              <a
                href={`mailto:${SUPPORT_EMAIL}`}
                data-testid="contact-email-btn"
                className="group inline-flex items-center justify-center gap-3 border border-gold/50 text-gold font-semibold tracking-[0.08em] text-sm sm:text-base px-8 py-4 rounded-full hover:bg-gold hover:text-ink transition-colors duration-300 w-fit"
              >
                <Mail className="w-[17px] h-[17px]" />
                {SUPPORT_EMAIL}
                <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1.5" />
              </a>
            </div>
          </Reveal>
        </div>
      </section>

      {children}

      <div className="bg-ink border-t border-white/8 py-6" data-testid="sms-consent-section">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
          <p
            className="text-center text-cream/45 text-xs leading-relaxed tracking-wide"
            data-testid="sms-consent-text"
          >
            By submitting your information or clicking Get Started, you agree to receive SMS
            messages from Iron Gate Consulting. Message and data rates may apply. Reply STOP to
            opt out at any time.
          </p>
        </div>
      </div>

      <footer className="bg-inkdeep border-t border-white/8 py-10" data-testid="site-footer">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="font-display text-sm text-cream/60 tracking-wide">
              IRON GATE <span className="text-gold">CONSULTING</span> &copy;{" "}
              {new Date().getFullYear()}
            </p>
            <div className="flex flex-wrap items-center justify-center gap-5 sm:gap-6 text-xs text-cream/50 tracking-wide">
              <Link to="/about" className="hover:text-gold transition-colors">
                About
              </Link>
              <Link to="/privacy-policy" className="hover:text-gold transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms-of-service" className="hover:text-gold transition-colors">
                Terms of Service
              </Link>
              <Link to="/contact" className="hover:text-gold transition-colors">
                Contact
              </Link>
            </div>
          </div>
          <p
            className="text-center sm:text-left text-cream/40 text-xs mt-6 pt-6 border-t border-white/8 tracking-wide"
            data-testid="powered-by-bottom"
          >
            {POWERED_BY_TEXT}
          </p>
        </div>
      </footer>
    </>
  );
};

export default ContactFooter;
